//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['competencias', 'titulo', 'slug', 'checkClass'],

  data() {
    return {
      hasPrograma: false,
    }
  },

  watch: {
    // slug(newVal, oldVal) {
    //   this.$axios
    //     .head(`/docs/${this.checkClass}/${newVal}.pdf`)
    //     .then(() => {
    //       this.hasPrograma = true
    //     })
    //     .catch(() => {
    //       this.hasPrograma = false
    //     })
    // },
  },

  computed: {
    setCompetencias: (v) => (v.competencias ? v.competencias : []),
  },
}
